//Carrossel
import React, { useState, useEffect } from 'react';
import './Carrossel.css';

// Importe as imagens dos seus banners aqui
// Substitua pelos caminhos reais das suas imagens
import bannerPai from './Images/scenery-designers-work.jpg';
import bannerNatal from './Images/medium-shot-people-looking-laptop.jpg';
import bannerEspecial from './Images/tiler-working-renovation-apartment.jpg';

const bannerData = [
  {
    id: 1,
    title: 'Seu espaço, com inteligência',
    description: 'Móveis planejados sob medida transformam seus espaços, unindo funcionalidade e estética. Eles são desenhados de forma personalizada para refletir sua individualidade, e aproveitando cada centímetro com inteligência.',
    image: bannerPai,
    alt: 'Banner sob medida'
  },
  {
    id: 2,
    title: 'Atendimento Personalizado',
    description: 'Para criar móveis planejados que se encaixem perfeitamente em sua vida, atendemos você de forma personalizada e focados em cada detalhe, desde o conceito inicial até a instalação final. Nossa atenção aos detalhes garante que seu projeto reflita sua personalidade e suas necessidades.',
    image: bannerNatal,
    alt: 'Banner Atendimento Personalizado'
  },
  {
    id: 3,
    title: 'Tranquilidade e segurança',
    description: 'Projetos que são sinônimo de solidez e confiança, com 5 anos de garantia, suporte e assistência técnica sempre disponível. Nosso compromisso é com a qualidade duradoura e com sua satisfação em todas as etapas!',
    image: bannerEspecial,
    alt: 'Banner Tranquilidade e Segurança'
  }
];

const Carrossel = () => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  useEffect(() => {
    // Função para avançar para o próximo banner
    const nextBanner = () => {
      setCurrentBannerIndex((prevIndex) => 
        (prevIndex + 1) % bannerData.length // Volta ao início se chegar ao fim
      );
    };

    // Configura um intervalo para trocar os banners a cada 5 segundos (5000ms)
    const intervalId = setInterval(nextBanner, 8000); // Ajuste o tempo aqui se desejar

    // Função de limpeza: importante para parar o intervalo quando o componente for desmontado
    return () => clearInterval(intervalId);
  }, []); // Array de dependências vazio para rodar apenas uma vez na montagem

  return (
    <div className="carousel-container">
      {/* Container dos banners, que se moverá */}
      <div 
        className="carousel-inner" 
        style={{ transform: `translateX(-${currentBannerIndex * 100}%)` }}
      >
        {bannerData.map((banner) => (
          <div className="carousel-item" key={banner.id}>
            <div className="carousel-content">
              <h2 className="carousel-title">{banner.title}</h2>
              <p className="carousel-description">{banner.description}</p>
            </div>
            <img 
              src={banner.image} 
              alt={banner.alt} 
              className="carousel-image" 
            />
          </div>
        ))}
      </div>

      {/* Indicadores de navegação (bolinhas) */}
      <div className="carousel-indicators">
        {bannerData.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentBannerIndex ? 'active' : ''}`}
            onClick={() => setCurrentBannerIndex(index)}
            aria-label={`Ir para o slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carrossel;